export default __webpack_public_path__ + "static/McLaren-dbd8d95806746cc427243f89ea8a1261.woff2";